<footer class="layout-footer"><ng-content></ng-content></footer>
